import React, { Component } from 'react';
import './preloader.css';

export default class Preloadr extends Component {
  getStyle() {
    return this.props.style || {};
  }

  render() {
    return <div className="rdp-react-template-component-preloader" style={this.getStyle()}>
      <div className="rdp-react-template-component-preloader-logo"></div>
    </div>
  }
}
